export default __webpack_public_path__ + "static/media/gallery_11.cdf622a3.jpg";